import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../features/Home/redux/homeSlice";
import megamenuReducer from "../components/Navbars/redux/megaMenuSlice";
import productDetailReducer from "../features/Products/pdp/redux/productDetailSlice";
import authReducer from "../features/Auth/redux//authSlice";
import cartReducer from "../features/Checkout/Cart/redux/cartSlice";
import wishlistReducer from "../components/Wishlist/WishlistSlice";
import profileReducer from "../features/Account/profile/redux/profileSlice";
import addressReducer from "../features/Account/address/redux/addressSlice";
import pincodeReducer from "../features/Products/pdp/redux/pincodeSlice";
import checkoutReducer from "../features/Checkout/Summay/redux/checkoutSlice";
import orderHistoryReducer from "../features/Account/order/redux/orderHistorySlice";
import orderDetailReducer from "../features/Account/order/redux/orderDetailSlice";
import productReducer from "../features/Products/listing/redux/productsSlice";
import promotionsReducer from "../features/Products/promotion/redux/promotionsSlice";
import searchProductReducer from "../features/Products/search/redux/searchProductSlice";
//searchProductReducer
import topPicksReducer from "../features/Products/topPicks/redux/topPicksSlice";
import collectionsReducer from "../features/Collection/redux/collectionsSlice";
import contactReducer from "../features/Content/contact/redux/contactSlice";
import aboutReducer from "../features/Content/about/redux/aboutSlice";
import faqReducer from "../features/Content/faq/redux/faqSlice";
import sizeGuideReducer from "../features/Content/guides/sizeGuide/redux/sizeGuideSlice";
import styleGuideReducer from "../features/Content/guides/styleGuide/redux/styleGuideSlice";
import blogReducer from "../features/Content/blog/bloglist/redux/blogSlice";
import policyReducer from "../features/Content/policy/redux/policySlice";
import trackShipmentReducer from "../features/Content/tracking/redux/trackOrderSlice";
import videoGalleryReducer from "../features/Content/gallery/video/redux/videoGallerySlice";
import floorFinderReducer from "../features/Products/floorMatcher/redux/FloorMatcherSlice";
// QuickView
import quickviewReducer from "../features/Products/quickView/redux/productsQuickViewSlice";
import bestsellerReducer from "../features/Products/promotion/redux/BestsellersBannerSlice";

export const store = configureStore({
  reducer: {
    home: homeReducer,
    megamenu: megamenuReducer,
    products: productReducer,
    promotions: promotionsReducer,
    searchProduct: searchProductReducer,
    topPicks: topPicksReducer,
    productDetail: productDetailReducer,
    quickView: quickviewReducer,
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    profile: profileReducer,
    address: addressReducer,
    floorFinder: floorFinderReducer,
    pincode: pincodeReducer,
    checkout: checkoutReducer,
    orders: orderHistoryReducer,
    orderDetail: orderDetailReducer,
    collections: collectionsReducer,
    contact: contactReducer,
    about: aboutReducer,
    faq: faqReducer,
    sizeGuide: sizeGuideReducer,
    styleGuide: styleGuideReducer,
    blog: blogReducer,
    policy: policyReducer,
    trackOrder: trackShipmentReducer,
    videoGallery: videoGalleryReducer,
    bestseller: bestsellerReducer, // ✅ MUST EXIST
  },
});